<template>
    <colla id="collapp" @mouseover="hovered = true" @mouseleave="hovered = false" :class="{'colla-element-of':hovered == true, 'collapp-comment-mode':commentMode == true}" v-on:click="addThread" >

        <colla class="collapp-control-panel" v-draggable="draggableValue">
            <colla :ref="handleId" class="collapp-handle">
                <img :src="rootUrl + '/dist/logo.png'" alt="move" class="collapp-dragable-handle">
            </colla>
            <colla class="collapp-pin collapp-dot collapp-blue collapp-large" title="click to start comment mode" v-on:click="commentModeToogle">+</colla>
        </colla>

        <colla class="collapp-threads" v-show="commentMode">
            <colla class="collapp-thread" v-for="(thread, index) in threads" :style="setThreadStyle(thread)" :data-thread-id="thread.id">
                <colla class="collapp-pin collapp-dot collapp-blue" v-draggable :data-thread-id="thread.id" @click="getThreadComments(thread.id)" @mouseup="onStDragging">
                    {{ index + 1 }}
                </colla>
                <colla class="collapp-content" v-show="showComments == thread.id" >
                    <button @click="deleteThread(index)" class="collapp-close">x</button>
                    <colla class="collapp-name">{{ thread.name }}</colla>
                    <colla class="collapp-time">{{ thread.time | time }}</colla>

                    <CommentList :thread="thread.id"/>
                </colla>
            </colla>
        </colla>

        <colla class="collapp-window-info" v-show="commentMode">
            RecordSize {{ projectScreen.width }}x{{ projectScreen.height }}<br> your window sizes {{ screen.width }}x{{ screen.height }}
        </colla>

    </colla>
</template>

<script>

    import CommentList from './CommentList.vue'
    import { Draggable } from 'draggable-vue-directive'

    export default {

        components: {
            CommentList
        },

        directives: {
            Draggable,
        },

        data() {
            return {
                project: null,
                projectScreen: {
                    width: 0,
                    height: 0
                },
                screen: {
                    width: 0,
                    height: 0
                },
                hovered: false,
                commentMode: false,
                showComments: false,
                handleId: "handle-id",
                draggableValue: {
                    initialPosition: { x: 10, y: 10 },
                    handle: undefined
                },
                draggablePin: {
                    //handle: undefined,
                    //onPositionChange: this.onPosChanged,
                    //onStopDragging: this.onStopDragging
                },
                //onPositionChange: this.onPosChanged,
                onStopDragging: this.onStDragging,
                rootUrl: this.$http.options.root,
                threads: [],
                iconOffset: 25
            }
        },

        mounted() {
            this.draggableValue.handle = this.$refs[this.handleId];
            this.draggablePin.handle = this.$refs;
            this.draggablePin.onStopDragging = this.onStDragging;
        },

        created() {
            this.loading = true;

            // this.registerProject();

            // for test
            // this.getThreads();

            // get params from url
            let uri = window.location.search.substring(1);
            let params = new URLSearchParams(uri);
            let project = params.get("collaP");

            // set project id
            if(project !== null)
            {
                this.project = project;
            }

            window.addEventListener('resize', this.handleResize);
            this.handleResize();
        },

        destroyed() {
            window.removeEventListener('resize', this.handleResize);
        },

        methods: {
            handleResize() {
                this.screen.width = window.innerWidth;
                this.screen.height = window.innerHeight;
                // this.window.resizeTo(500,500);
            },

            registerProject() {

                if(this.project === null)
                {

                    console.log(this.screen);

                    let data = JSON.stringify({
                        name: window.location.href, //window.location.pathname,
                        status: 1,
                        time: new Date(),
                        screen: JSON.stringify(this.screen)
                    });

                    console.log(data);

                    this.$http.post(this.$http.options.api + '/projects', data, {
                        headers: {
                            'Content-Type': 'application/ld+json'
                        }}).then((response) => {
                        // success callback

                        // set project id
                        this.project = response.data.id;
                        this.projectScreen = JSON.parse(response.data.screen);

                        // stop loading
                        // this.loading = false;

                        // load threads for project id
                        this.getThreads();
                    }, (response) => {
                        // error callback
                        console.error(response);
                    });

                }
                else
                {
                    this.$http.get(this.$http.options.api + '/projects/' + this.project).then((response) => {

                        // get screen size from project
                        this.projectScreen = JSON.parse(response.data.screen);

                    }, (response) => {
                        // error callback
                        console.error(response);
                        this.loading = false;
                    });

                    // load from given param
                    this.getThreads();
                }
            },

            getThreads() {
                console.log('this.project: ' + this.project);
                // Fetch the threads
                this.$http.get(this.$http.options.api + '/threads?project=' + this.project).then((response) => {
                    // success callback
                    var collectionResponse = response.data['hydra:member'];
                    this.threads = collectionResponse;
                    console.log(this.threads);
                    this.loading = false;
                }, (response) => {
                    // error callback
                    console.error(response);
                    this.loading = false;
                });
            },

            setThreadStyle: function(item){
                let pos = JSON.parse(item.position);
                return 'left:'+pos.left+'; top:'+pos.top+';';
            },

            // toggle comment mode
            commentModeToogle: function(){
                // start comment mode
                this.commentMode = !this.commentMode;
                // some code to filter users

                this.registerProject();
            },

            getThreadComments: function (id) {

                // hide all comment lists
                this.showComments = false;

                // show comment list of active thread
                this.showComments = id;


            },

            addThread: function (event) {

                // return if comment mode is not active
                if(!this.commentMode)
                    return;

                // return if thread pin is clicked
                if(event.target.className.match(/\bpin\b/))
                    return;

                // return if close button of thread is clicked
                if(event.target.className.match(/\bclose\b/))
                    return;

                // return if not in app div
                if(!event.target.className.match(/\bcomment-mode\b/))
                    return;

                // hide all other comment lists
                this.showComments = false;

                // add new thread to project and set position
                //console.log(event.clientX); // x coordinate
                //console.log(event.clientY); // y coordinate

                // pageX/Y gives the coordinates relative to the <html> element in CSS pixels.
                //console.log(event.pageX);
                //console.log(event.pagey);

                // screenX/Y gives the coordinates relative to the screen in device pixels.
                //console.log(event.screenX);
                //console.log(event.screenY);

                if (event) {
                    console.log('tagName: ' + event.target.tagName);
                    console.log('target: ' + event.target);
                    console.log(event.target);
                }

                let threadCount = this.threads.length + 1;

                console.log(event.clientX);
                console.log(event.clientY);

                //let newPos = '{"left": "'+event.clientX - 25+'px", "top": "'+event.clientY - 25+'px"}';
                let newPos = '{"left": "'+(event.clientX - this.iconOffset)+'px" ,"top": "'+(event.clientY - this.iconOffset)+'px"}';

                console.log(newPos);

                let data = {
                    name: event.target.tagName,
                    time: new Date(),
                    position: newPos,
                    status: 1,
                    project: "/api/projects/"+this.project,
                    screen: {
                        width: screen.width,
                        height: screen.height
                    }
                };

                // update thread object
                this.threads.push(data);

                // show comment box
                this.showComments = threadCount;

                // update api
                this.$http.post(this.$http.options.api + '/threads', JSON.stringify(data), {
                    headers: {
                        'Content-Type': 'application/ld+json'
                    }}).then((response) => {
                    // success callback
                }, (response) => {
                    // error callback
                    console.error(response);
                });
            },

            deleteThread: function (index) {
                this.threads.splice(index,1)
            },
            changeThreadPosition: function (thread, x, y, parent) {

                console.log('thread');
                console.log(thread);


                let newPos = '{"left": "'+x+'px" ,"top": "'+y+'px"}';

                parent.style = newPos;

                // update thread via api
                let data = JSON.stringify({
                    position: newPos
                });

                this.$http.put(this.$http.options.api + '/threads/'+thread, data, {
                    headers: {
                        'Content-Type': 'application/ld+json'
                    }}).then((response) => {
                    // success callback
                }, (response) => {
                    // error callback
                    console.error(response);
                });

                // update array
                console.log(this.threads);

                this.threads[thread-1].position = newPos;

                console.log('change thread pos for: '+thread+' with x '+x+' and y '+y);
            },
            // draggable pin
            onPosChanged: function(positionDiff, absolutePosition, event) {
                console.log('onPosChanged');
                /*
                console.log(event);
                console.log("positionDiff", positionDiff);
                console.log("absolutePosition", absolutePosition);*/
            },
            onStDragging: function(e){

                let tag = e.target,
                    draggableState = JSON.parse(tag.getAttribute('draggable-state'));

                // retrun if not draggable element
                if(typeof draggableState !== 'object')
                    return;

                // return if draggable element is not move
                if(typeof draggableState.startDragPosition === 'undefined' || draggableState.startDragPosition.left === draggableState.currentDragPosition.left &&
                    draggableState.startDragPosition.top === draggableState.currentDragPosition.top)
                {
                    return;
                }

                // set position of parent element
                let parent = e.target.parentElement;
                parent.style.left = (e.clientX-this.iconOffset)+'px';
                parent.style.top = (e.clientY-this.iconOffset+3)+'px';
            }
        },

        filters: {
            time: function (value) {

                var today = new Date();

                const endDate = new Date(value);
                const days = parseInt((endDate - today) / (1000 * 60 * 60 * 24));
                const hours = parseInt(Math.abs(endDate - today) / (1000 * 60 * 60) % 24);
                const minutes = parseInt(Math.abs(endDate.getTime() - today.getTime()) / (1000 * 60) % 60);
                const seconds = parseInt(Math.abs(endDate.getTime() - today.getTime()) / (1000) % 60);

                //console.log('######');
                //console.log('days ' + days);
                //console.log('hours ' + hours);
                //console.log('minutes ' + minutes);
                //console.log('seconds ' + seconds);

                // return now
                if(days == 0 && hours == 0 && minutes < 1)
                    return 'now';

                if(days == 0 && hours == 0)
                    return minutes + 'm';

                if(days == 0 && hours > 0)
                    return hours + 'h' + minutes + 'm';

                if(days < 0)
                    return Math.abs(days) + 'd';


                return '-';
            }
        }

    }

</script>

<style lang="scss">

    #collapp {
        font-family: 'Raleway', sans-serif;
        font-size: 1rem;
        width: 40px;
        margin: 0;
        text-align: center;
        transition: all ease .6s;
        right: 30px;
        bottom: 30px;
        position: absolute;
        min-height: 60px;
        z-index: 16000000;

        &.collapp-comment-mode {
            width: 100%;
            height: 100%;
            right: inherit;
            bottom: inherit;
            top: 10px;
            left: 10px;
        }

        .collapp-pin {
            position: absolute;
            width: 30px;
            height: 30px;
            background: #999;
            box-shadow: 0 1px 3px rgba(0,0,0,0.5);
            text-align: center;
            line-height: 32px;
            font-size: 1em;
            font-weight: 800;
            color: #fff;
            cursor: pointer;
            -webkit-transition: ease-in-out .15s;
            -moz-transition: ease-in-out .15s;
            -o-transition: ease-in-out .15s;
            transition: ease-in-out .15s;
            z-index: 16000001
        }

        .collapp-dot {
            border: 3px solid #fff;
            -moz-border-radius: 100%;
            -webkit-border-radius: 100%;
            border-radius: 100%;
            -moz-box-shadow: 0 1px 3px rgba(0,0,0,0.5);
            -webkit-box-shadow: 0 1px 3px rgba(0,0,0,0.5);
        }

        .collapp-blue {
            background: #6f8aa7;
        }

        .collapp-control-panel {
            background: #6f8aa7;
            position: absolute;
            width: 34px;
            padding: 30px 10px 10px 10px;

            .collapp-dragable-handle {
                width: 30px;
                height: 20px;
                margin-top: 10px;
                position: absolute;
                top: -15px;
                left: 50%;
                margin-left: -15px;
            }

            .collapp-pin {
                position: relative;
                display: inline-block;
            }
        }

        .collapp-window-info{
            text-align: right;
            position: fixed;
            top: 30px;
            right: 10px;
            background: #6f8aa7;
            color: #fff;
            font-size: xx-small;
            padding: 2px;
        }

        .collapp-threads {

            .collapp-thread {
                position: absolute;

                .collapp-content {
                    position: relative;
                    margin-top: 60px;
                    margin-left: -25px;
                    z-index: 16000002;

                    &:before {
                        content: '';
                        width: 0px;
                        height: 0px;
                        display: inline-block;
                        vertical-align: middle;
                        border-left: 10px solid transparent;
                        border-right: 10px solid transparent;
                        border-bottom: 16px solid #fff;
                        position: absolute;
                        top: -16px;
                        left: 33px;
                    }

                    .collapp-time, .collapp-name {
                        position: absolute;
                        float: none;
                        left: 75px;
                        top: -50px;
                        font-size: .8em;
                        color: #999;
                    }

                    .collapp-time {
                        top: -31px;
                        font-size: .7em;
                    }

                    .collapp-close {
                        float: right;
                        margin-top: 20px;
                    }
                }
            }
        }
    }



    @media (max-width: 1200px) {

        #collapp {
            width: 80%;

            .collapp-comment-list .collapp-msg {
                width: 80%;
            }
        }


    }

    @media (max-width: 600px) {

        #collapp {
            width: 95%;
            margin: 2rem auto;

            .collapp-spinner {
                width: 20px;
                height: 20px;
                background-color: #47b784;
                display: inline-block;
                -webkit-animation: sk-rotateplane 1.2s infinite ease-in-out;
                animation: sk-rotateplane 1.2s infinite ease-in-out;
            }
        }
    }



    @-webkit-keyframes sk-rotateplane {
        0% {
            -webkit-transform: perspective(120px)
        }
        50% {
            -webkit-transform: perspective(120px) rotateY(180deg)
        }
        100% {
            -webkit-transform: perspective(120px) rotateY(180deg) rotateX(180deg)
        }
    }

    @keyframes sk-rotateplane {
        0% {
            transform: perspective(120px) rotateX(0deg) rotateY(0deg);
            -webkit-transform: perspective(120px) rotateX(0deg) rotateY(0deg);
            background-color: #47b784;
        }
        50% {
            transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);
            -webkit-transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);
            background-color: #36495d;
        }
        100% {
            transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);
            -webkit-transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);
            background-color: #47b784;
        }
    }
</style>


// WEBPACK FOOTER //
// App.vue?da91f40a